<template>
  <v-link
    :to="item.url"
    class="o-typography--action o-typography--stateful u-desktop-only"
    target="_blank"
  >
    <img
      v-if="item.image"
      class="c-navbar__image"
      :src="item.image"
      @load="$emit('load')"
    >
    <template v-else>
      <v-icon
        v-if="item.icon"
        class="o-icon--align-middle c-navbar__link-icon"
        :icon="item.icon"
      ></v-icon>
      {{ item.name }}
    </template>
  </v-link>
</template>
<script>
  import { VIcon, VLink } from '@/index/shared/components';

  export default {
    components: {
      VIcon,
      VLink,
    },
    props: {
      item: Object,
    },
  };
</script>
